import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Eventcard from "./Eventcard";
import Grid from "@material-ui/core/Grid";
import Hero from "./Hero";

const useStyles = makeStyles((theme) => ({
  main: {
    backgroundColor: "#ffffff",
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
}));

function EventList({ events }) {
  const classes = useStyles();

  return (
    <main className={classes.main}>
      <Hero />
      <Container className={classes.cardGrid} maxWidth="md">
        <Grid container spacing={4}>
          {events.map(
            ({ id, sku, name, description, image, type, personalizable }) => (
              <Eventcard
                key={id}
                id={id}
                sku={sku}
                name={name}
                description={description}
                image={image}
                type={type}
                personalizable={personalizable}
              />
            )
          )}
        </Grid>
      </Container>
    </main>
  );
}

export default EventList;
